import { format, startOfMonth, subDays } from 'date-fns'
import { useEffect, useMemo, useState } from 'react'
import {
  FinancialReport,
  ReportRepository,
} from '../repositories/ReportRepository'
import { useData } from './useData'
import { useOwnersSimple } from './useOwnersSimple'

const reportRepository = new ReportRepository()

export function useReports(
  initialStartDate?: Date | null,
  initialEndDate?: Date | null
) {
  const yesterday = subDays(new Date(), 1)
  const [startDate, setStartDate] = useState(
    initialStartDate || startOfMonth(new Date())
  )
  const [endDate, setEndDate] = useState(initialEndDate || yesterday)
  const [selectedOwnerId, setSelectedOwnerId] = useState<string>('all')

  const { owners } = useOwnersSimple()

  useEffect(() => {
    if (initialStartDate) {
      setStartDate(initialStartDate)
    }
    if (initialEndDate) {
      setEndDate(initialEndDate)
    }
  }, [initialStartDate, initialEndDate])

  const { data: payoutData, isLoading: loading } = useData<FinancialReport>({
    repository: reportRepository,
    fetcher: (repo) =>
      (repo as ReportRepository).getAll({
        startDate: format(startDate, 'yyyy-MM-dd'),
        endDate: format(endDate, 'yyyy-MM-dd'),
        ownerId: selectedOwnerId === 'all' ? undefined : selectedOwnerId,
      }),
    queryKey: [
      'financialReport',
      format(startDate, 'yyyy-MM-dd'),
      format(endDate, 'yyyy-MM-dd'),
      selectedOwnerId,
    ],
  })

  const totalDays = useMemo(() => {
    return Math.ceil(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    )
  }, [startDate, endDate])

  return {
    startDate,
    endDate,
    selectedOwnerId,
    payoutData: (payoutData as FinancialReport[]) || [],
    owners: owners || [],
    loading,
    totalDays,
    setStartDate,
    setEndDate,
    setSelectedOwnerId,
  }
}
